export const blockIconsUiactionsCheckBoxNew = (
	<span className='material-symbols-outlined'>check_box</span>
);
